import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";

const Footer = () => {
  return (
    <footer>
      <div className="footer-area pt-100 footer-bg2 p-relative">
        <div className="container">
          <div className="footer-top">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="footer-widget footer-2-col-1 mb-30">
                  <div className="footer-widget-logo mb-20">
                    <a href="/">
                      <img
                        src="/images/logo.png"
                        width={120}
                        alt="footer logo"
                      />
                    </a>
                  </div>
                  <div className="footer-widget-about mb-40">
                    <p
                      style={{
                        fontSize: "14px",
                        lineHeight: "1.8",
                      }}
                    >
                      Happy Pay Fintech is a growing digital financial services
                      company providing secure and reliable solutions like AEPS,
                      DMT, CMS, PAN Card and Utility Bill Payments. Our mission
                      is to empower retailers and customers with fast,
                      transparent and easy-to-use fintech services across India.
                    </p>
                  </div>
                  {/* <div className="footer-widget-content">
                    <div className="footer-widget-social2">
                      <a className="footer-facebook" href="#">
                        <i className="fa-brands fa-facebook-f" />
                      </a>
                      <a href="#">
                        <i className="fa-brands fa-twitter" />
                      </a>
                      <a className="footer-linkedin" href="#">
                        <i className="fa-brands fa-linkedin-in" />
                      </a>
                      <a className="footer-insta" href="#">
                        <i className="fa-brands fa-instagram" />
                      </a>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="footer-widget footer-widget-2 footer-2-col-2 mb-40">
                  <h4 className="footer-widget-title mb-15">Quick Links</h4>
                  <div className="footer-widget-link">
                    <ul>
                      <li>
                        <a href="/">Home</a>
                      </li>
                      <li>
                        <a href="/about-us">About Us</a>
                      </li>
                      <li>
                        <a href="/services">Services</a>
                      </li>
                      <li>
                        <a href="/privacy-policy">Privacy Policy</a>
                      </li>
                      <li>
                        <a href="/terms-and-conditions">Terms & Conditions</a>
                      </li>
                      <li>
                        <a href="/refund-policy">Refund Policy</a>
                      </li>

                      <li>
                        <a href="/grievance-policy">Grievance Policy</a>
                      </li>
                      <li>
                        <a href="/contact-us">Contact Us</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="footer-widget footer-widget-2 footer-2-col-3 mb-40">
                  <h4 className="footer-widget-title mb-15">Services</h4>
                  <div className="footer-widget-link">
                    <ul>
                      <li>
                        <a href="/services">AEPS</a>
                      </li>
                      <li>
                        <a href="/services">DMT</a>
                      </li>
                      <li>
                        <a href="/services">CMS</a>
                      </li>
                      <li>
                        <a href="/services">Utility Bill Payments</a>
                      </li>
                      <li>
                        <a href="/services">PAN Card</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="footer-widget footer-widget-2 footer-2-col-4 mb-40">
                  <h4 className="footer-widget-title mb-20">Contact Us</h4>
                  <div className="tpcontact-info-links">
                    <a href="tel:+919741314333">
                      <MdPhone size={18} style={{ marginRight: "8px" }} />
                      +91 9741314333
                    </a>

                    <a href="mailto:happypayfintech@gmail.com">
                      <MdEmail size={18} style={{ marginRight: "8px" }} />
                      happypayfintech@gmail.com
                    </a>

                    <a href="#">
                      <MdLocationOn size={18} style={{ marginRight: "8px" }} />
                      AYYAAND PAY FINTECH PRIVATE LIMITED, C/o Sri B.channayya,
                      Ter Bazar Main Road Kanakgiri, Near Partana Panchayat,
                      Kanakgiri, Koppal, Karnataka - 583283
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="row">
              <div className="col-lg-12">
                <div className="footer-widget-copyright footer-widget-copyright2 text-center">
                  <span>
                    © 2026 Copyrights by AYYAAND PAY FINTECH PRIVATE LIMITED.
                    All Rights Reserved.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
